export default __webpack_public_path__ + "static/media/video-still.66bc21bc.png";